module.exports = __webpack_public_path__ + "img/profile.ad01addd.svg";